// @flow

import React from 'react';
import { render } from 'react-dom';
import logger from './utils/logger';
import App from './App';
import getAppConfig from './constants/getAppConfig';

window.icisHeader = { logger, config: getAppConfig() };

function setup() {
  if (window.self !== window.top) {
    return;
  }

  const root = document.querySelector(`#icis-app-root`);

  if (root) {
    render(<App />, root);
  } else {
    // eslint-disable-next-line no-console
    console.error(`#icis-app-root does not exist, cannot mount React`, root);
    logger.error(`#icis-app-root does not exist, cannot mount React`);
  }
}

export default setup();
